<template>
  <aha-icon
    v-bind="$props"
    :name="logoType"
    :maintainColor="useDefaultColor"
    :viewBox="viewBox"
  />
</template>

<script>
import AhaIcon from './Icon.vue'

export default {
  components: {
    AhaIcon,
  },
  props: {
    iconOnly: {
      type: Boolean,
      default: false,
    },
    useDefaultColor: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    logoType() {
      return this.iconOnly ? 'logo-icon-only' : 'logo'
    },
    viewBox() {
      return this.iconOnly ? '0 0 567 580' : '0 0 799 183'
    },
  },
}
</script>

<style lang="scss">
.path-fill-current path {
  @apply fill-current;
}
</style>
